import React from 'react';

const hrStyles = {
  borderBottom: `var(--default-border)`,
  gridColumn: 'start / end',
};

export function HorizontalRule() {
  return (
    <>
      <div className="horizontal-rule night-aware" style={hrStyles} />
    </>
  );
}
